module.exports = __webpack_public_path__ + "img/sample.767c067c.webp";